var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatternN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "patternN",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M347.26,312v-151.18h1.46v151.3c-.49-.04-.97-.08-1.46-.12h0Z",
    className: "patternColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M340.26,246.28v-85.53h1.26c1.6,14.5.92,28.99.12,43.56-.76,13.97.75,28.04.86,42.05-.75-.03-1.49-.05-2.24-.08Z",
    className: "patternColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.6,619.38c-.32-5.65-.84-11.31-.89-16.96-.06-6.23.46-12.46.45-18.69-.01-6.12-.45-12.23-.55-18.35-.1-6.14-.02-12.29,1.15-18.87.58,1.19,1.67,2.39,1.65,3.58-.16,11.42-.55,22.84-.77,34.26-.03,1.42.79,2.85.8,4.28.07,10.17.04,20.34.04,30.51l-1.88.24h0Z",
    className: "patternColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M309.31,623.29v-52.44c.6-.02,1.21-.03,1.81-.05.12,2.48.38,4.97.34,7.44-.2,15.02-.46,30.03-.77,45.04h-1.39.01Z",
    className: "patternColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M502.84,623.7c-2.8-2.42-3.26-48.45-.93-52.74,1.83,2.56,2.63,43.62.93,52.74Z",
    className: "patternColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M501.13,263.26c3.22,2.82,3.26,49.59,0,52.61v-52.61h0Z",
    className: "patternColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.12,263.22c3.25,2.92,3.24,49.71,0,52.63v-52.63Z",
    className: "patternColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M210.06,263.38c.47,1.01,1.35,2.02,1.36,3.03.09,15.45.08,30.9.02,46.35,0,.98-.63,1.96-.97,2.95l-1.36-.29v-51.63c.32-.13.64-.27.96-.4h-.01Z",
    className: "patternColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M402.58,624.69c-.99-2.19-1.92-3.29-1.93-4.4-.09-15.63-.08-31.25-.01-46.88,0-.86.65-1.71,1.07-2.75,2.04,2.89,2.8,44.44.87,54.03h0Z",
    className: "patternColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M602.82,315.67c-.92-.29-1.74-.44-1.74-.58-.06-16.77-.05-33.54.43-50.63.66,1.86,1.87,3.72,1.88,5.58.14,14.64.06,29.29.01,43.93,0,.45-.31.9-.59,1.69h.01Z",
    className: "patternColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M479.19,227.74c-.53-.72-1.52-1.43-1.52-2.15-.09-14.27-.07-28.53-.07-43.75,1.45,1.17,2.68,1.7,2.68,2.24.1,14.41.08,28.81.08,43.22-.39.15-.79.3-1.18.45h.01Z",
    className: "patternColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.07,182.54c3.31,2.52,3.48,42.43,0,45.2v-45.2Z",
    className: "patternColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M285.87,336c3.81,3.42,3.38,42.96,0,45.42v-45.42h0Z",
    className: "patternColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M477.88,335.99c3.82,3.46,3.37,43,0,45.42v-45.42h0Z",
    className: "patternColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M379.01,227.68c-.48-1.01-1.29-1.98-1.38-3.02-1.47-17.83-.22-40.06,2.54-41.98v44.61c-.39.13-.78.27-1.16.4h0Z",
    className: "patternColor"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M577.58,380.94c0-14.75-.03-29.49.02-44.24.96.03,1.92.06,2.88.09-.1,14.81.21,29.62-.18,44.43-.91-.09-1.82-.18-2.72-.27h0Z",
    className: "patternColor"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M409.02,136.57c3.39,3.15,3.52,41.58,0,45.12v-45.12Z",
    className: "patternColor"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M316.87,596.8c2.64,3.39,3.98,33.63,2.54,43-.16,1.01-1.01,1.91-2.54,2.44v-45.43h0Z",
    className: "patternColor"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M409.11,598.05c3.36,3.96,2.97,42,0,44.77v-44.77Z",
    className: "patternColor"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M509.87,335.14c-2.27-4.35-1.81-42.34.54-44.43,1.93,4.7,1.49,41.64-.54,44.43Z",
    className: "patternColor"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M316.76,335.19c0-14.59-.01-29.17.08-43.76,0-.31,1.24-.6,1.96-.93,1.67,8.04.94,42.01-2.04,44.68h0Z",
    className: "patternColor"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M217.24,336.2v-46.31c.99,1.17,2.12,1.88,2.12,2.59.07,13.81,0,27.63-.08,41.44,0,.36-.62.72-2.04,2.27h0Z",
    className: "patternColor"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M578.21,490.36c2.8,2.4,3.26,40.47.94,44.73-1.84-2.55-2.61-35.73-.94-44.73Z",
    className: "patternColor"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M286.25,490.35c2.8,2.48,3.21,40.56.89,44.77-1.81-2.59-2.55-36.22-.89-44.77h0Z",
    className: "patternColor"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M311.18,461.38c-2.77-1.99-4.02-23.39-2.55-40.99.09-1.03.91-2.01,1.39-3.01.39.13.77.27,1.16.4v43.6h0Z",
    className: "patternColor"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M216.79,488.23v-43.31c.33-.14.66-.29,1-.43.56,1.19,1.61,2.38,1.62,3.58.12,12.31.11,24.63.02,36.95,0,1.19-.73,2.37-1.13,3.56-.5-.12-1.01-.23-1.51-.35Z",
    className: "patternColor"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M479.77,491.33v44.96c-3.56-5.62-2.67-42.01,0-44.96h0Z",
    className: "patternColor"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M310.83,374.97v41.39c-2.72-2.93-3.17-36.83,0-41.39Z",
    className: "patternColor"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M502.83,374.97v41.39c-2.72-2.92-3.17-36.82,0-41.39Z",
    className: "patternColor"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M502.66,569.48c-2.58-2.05-3.13-35.96,0-40.5v40.5Z",
    className: "patternColor"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M400.57,262.21c0-11.92-.03-23.85.03-35.77,0-1.56.44-3.13.78-4.67.02-.1.92,0,1.36,0v40.42l-2.17.03h0Z",
    className: "patternColor"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M310.89,221.31v41.36c-3.22-3.7-3.11-38.68,0-41.36h0Z",
    className: "patternColor"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M509.01,597.56c3.41,3.26,3.53,37.63,0,41.12v-41.12Z",
    className: "patternColor"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M502.9,261.98c-3.28-4.02-2.88-38.14,0-40.71v40.71Z",
    className: "patternColor"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M602.76,528.79v40.93c-.8-.69-1.99-1.23-1.99-1.79-.1-13.06-.08-26.11-.08-39.17.69,0,1.38.01,2.08.02h-.01Z",
    className: "patternColor"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M310.81,569.71c-2.57-2.28-3.3-34.57-1.31-40.51,2.24,1.79,3.25,30.62,1.31,40.51Z",
    className: "patternColor"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M210.67,569.36c-2.58-2.15-3.2-35.79,0-40.44v40.44Z",
    className: "patternColor"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M601.96,612.24c-2.83-13.67-.8-27.46-1.38-41.18.91-.04,1.81-.08,2.72-.12.06,4.33.15,8.67.18,13,.03,4.82,0,9.64,0,14.46v13.95c-.51-.04-1.02-.07-1.52-.11h0Z",
    className: "patternColor"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M340.33,614.4v-53.58h1.38v53.57h-1.38Z",
    className: "patternColor"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M341.78,253.7v53.69h-1.44v-53.69h1.44Z",
    className: "patternColor"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M549.3,236.9v39.16l-1.02.44c-.57-1.18-1.61-2.36-1.62-3.55-.13-10.94-.12-21.88-.01-32.82.01-1.2.84-2.39,1.3-3.59.45.12.91.24,1.36.35h0Z",
    className: "patternColor"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M449.08,236.44v39.85c-3.51-2.78-3.51-36.56,0-39.85Z",
    className: "patternColor"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M547.22,544.22c3.52,5.11,2.68,37.69,0,39.1v-39.1Z",
    className: "patternColor"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M256.98,276.06c-3.65-4.36-2.94-37.07,0-39.27v39.27Z",
    className: "patternColor"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M340.27,357.27v-42.6h1.48c1.3,14.15.91,28.31.25,42.48-.58.04-1.15.09-1.73.13h0Z",
    className: "patternColor"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M348.76,622.68v43.85c-1.04-2.13-2.1-3.29-2.11-4.46-.12-13.13-.07-26.26-.07-39.39h2.18Z",
    className: "patternColor"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M185.51,535.07c.53-13.42-1.09-26.86,2.38-40.25v40.17l-2.38.08Z",
    className: "patternColor"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M257.53,543.94c-.28,13.79.43,26.66-1.12,39.44-2.97-5.5-2.19-36.35,1.12-39.44Z",
    className: "patternColor"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M501.73,417.72c3.04,9.57,2,36.31-1.15,39.29,0-13.65-.03-26.5,1.15-39.29Z",
    className: "patternColor"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M256,429.68c-.47-1.01-1.29-1.99-1.37-3.03-1.38-16.79-.22-34.04,2.54-35.95v38.58l-1.17.39h0Z",
    className: "patternColor"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M402.95,301.86c-3.26-2.96-3.24-35.76,0-38.63v38.63Z",
    className: "patternColor"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M439.92,308.22v-56.37c.32,0,.64,0,.97,0v56.38h-.97Z",
    className: "patternColor"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M249.13,251.85v56.37h-.97v-56.36h.97Z",
    className: "patternColor"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M546.78,428.95c-1.25-24.26-.56-36.69,2.07-38.17,2.07,9.59.85,35.65-2.07,38.17h0Z",
    className: "patternColor"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M341.82,622.75v40.64c-2.83-4.09-3.08-32.61,0-40.64Z",
    className: "patternColor"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M541.17,252.83v55.39h-.91v-55.39h.91Z",
    className: "patternColor"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M441.08,559.84v55.38h-.98v-55.38h.98Z",
    className: "patternColor"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M319.22,144.03c1.37,18.28.6,34.57-2.49,38.1,0-12.85-.02-24.83.1-36.82,0-.42,1.5-.83,2.39-1.28h0Z",
    className: "patternColor"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M457.15,582.15v37.14c-.37.14-.75.29-1.12.43-.48-.86-1.28-1.69-1.4-2.6-1.32-10.63-.09-32.83,2.52-34.98h0Z",
    className: "patternColor"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M434.44,662.09c-3.14-2.48-4.03-22.76-2.41-38.3,1.16,1.56,2.32,2.39,2.33,3.24.12,11.4.08,22.8.08,35.06h0Z",
    className: "patternColor"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M449.09,628.77v36.8c-3.72-2.64-3.5-34.37,0-36.8Z",
    className: "patternColor"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M263.21,312v-37.68c2.8,3.51,3.09,33.68,0,37.68Z",
    className: "patternColor"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M456.75,275.01v37.18h-1.44v-37.18h1.44Z",
    className: "patternColor"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M355.03,582.45c3.39,3.27,3.45,34.13,0,37.27v-37.27Z",
    className: "patternColor"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M531.85,354.66v-36.87c.35-.15.69-.3,1.04-.44.53.89,1.4,1.74,1.52,2.68,1.45,11.39.12,32.21-2.56,34.63Z",
    className: "patternColor"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M162.9,582.6c2.8,2.21,3.62,13.93,2.53,33.27-.07,1.27-.88,2.49-1.35,3.74l-1.18-.35v-36.66h0Z",
    className: "patternColor"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M256.82,511.76c-2.76-2.95-3.19-32.52-.93-36.77,1.86,2.42,2.58,28,.93,36.77Z",
    className: "patternColor"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M548.95,358.02c-3.31-3.71-3.01-33.84,0-36.83v36.83Z",
    className: "patternColor"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M257.14,321.25v37c-3.48-2.46-3.67-33.33,0-37Z",
    className: "patternColor"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M239.89,317.66c3.69,2.62,3.72,34.05,0,36.78v-36.78Z",
    className: "patternColor"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M240.28,471.77c2.8,1.48,3.39,31.95,0,37.59v-37.59Z",
    className: "patternColor"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M533.74,470.46v38.14c-2.77-3.36-2.97-33.53,0-38.14Z",
    className: "patternColor"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M556.9,311.97c-3.29-4.02-2.89-34.14,0-36.7v36.7Z",
    className: "patternColor"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M355.26,275.35c2.79,2.5,3.18,32.64.87,36.78-1.81-2.61-2.49-28.6-.87-36.78Z",
    className: "patternColor"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M548.82,511.71c-2.81-2.5-3.21-32.59-.89-36.77,1.81,2.59,2.5,28.45.89,36.77Z",
    className: "patternColor"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M432.05,163.63c3.32,2.82,3.51,33.45,0,37.13v-37.13Z",
    className: "patternColor"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68,205.42c-.32-.92-.92-1.83-.93-2.75-.04-11.3-.01-22.59.11-33.89,0-.42,1.16-.83,2.3-1.59v37.01c-.49.41-.99.81-1.48,1.22h0Z",
    className: "patternColor"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M447.26,583.71c-2.09-10.49-.89-33.91,1.72-35.5,1.63,10.09.76,33.27-1.72,35.5Z",
    className: "patternColor"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M264.22,582.42c.42,1.19,1.19,2.37,1.2,3.56.1,10.49.06,20.98.06,33.01-1.46-2.01-2.78-2.98-2.8-3.97-.15-10.75-.09-21.51-.09-32.26.54-.11,1.09-.23,1.63-.34h0Z",
    className: "patternColor"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M400.62,127.51c3.06,1.44,4.2,23.16,2.24,35.52-.99-1.13-2.15-1.84-2.16-2.56-.12-10.9-.08-21.8-.08-32.96Z",
    className: "patternColor"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M539.99,611.22v-51.37h1v51.38h-1Z",
    className: "patternColor"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M494.89,325.08v33.03c-2.77-2.57-3.54-27.59,0-33.03Z",
    className: "patternColor"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M302.05,358.22c-2.09-10.98-1.24-22.04-.84-33.09,2.54,2.45,3.19,24.89.84,33.09Z",
    className: "patternColor"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M201.02,358.27c-.63-11.06-.99-22.13.31-33.2.51,0,1.02-.02,1.53-.03v33.11l-1.84.11h0Z",
    className: "patternColor"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M594.95,325.19v32.81c-2.9-2.3-3.69-27.25,0-32.81Z",
    className: "patternColor"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M303.31,171.14v33.03c-3.61-1.88-4.04-28.91,0-33.03Z",
    className: "patternColor"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M495.31,171.21v33.03c-3.63-2.03-4.01-29.09,0-33.03Z",
    className: "patternColor"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M395.27,171.12v33.19c-3.56-2.72-3.94-29.2,0-33.19Z",
    className: "patternColor"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M595.15,478.52v32.97c-3.61-2.91-3.63-29.3,0-32.97Z",
    className: "patternColor"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M494.94,511.92c-3.18-3.47-3.21-29.04,0-33.96v33.96Z",
    className: "patternColor"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M303.07,511.68c-3.46-2.98-3.45-29.1,0-33.33v33.33h0Z",
    className: "patternColor"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M203.23,478.2v33.19c-3.57-2.45-3.82-28.8,0-33.19Z",
    className: "patternColor"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M347.23,314.84c2.24,12.24,3.44,24.33,1.21,36.31-.4-.02-.81-.04-1.21-.05v-36.26Z",
    className: "patternColor"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M456.56,432.88c.88,10.88.99,21.72.87,32.56-.95-.05-1.91-.09-2.86-.14.47-10.81-1.1-21.71,1.99-32.42h0Z",
    className: "patternColor"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M395.16,665.47c-3.65-2.92-3.63-28.91,0-32.92v32.92Z",
    className: "patternColor"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M564.48,532.79v40.49h-1.37v-40.49c.46,0,.91,0,1.37-.01h0Z",
    className: "patternColor"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M610.79,597.9v31.8c-3.9-10.36-1.38-21.07-2.28-31.61.76-.06,1.52-.12,2.28-.19Z",
    className: "patternColor"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M210.97,437.67c0,11.41,0,21.46-.06,31.52,0,.07-.89.14-2.32.36.6-10.43-1.71-20.74,2.38-31.88h0Z",
    className: "patternColor"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M562.98,265.13v-39.3h1.29v39.42c-.43-.04-.86-.08-1.29-.12Z",
    className: "patternColor"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M362.94,265.2v-39.36c.45,0,.91,0,1.36-.02,1.05,13.12.61,26.26.22,39.4-.52,0-1.05-.02-1.57-.02h0Z",
    className: "patternColor"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M270.94,419.23v-40.34l1.26-.02v40.35c-.42,0-.84,0-1.26.01h0Z",
    className: "patternColor"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M270.98,573.22v-40.44c.42,0,.84-.01,1.26-.02v40.45h-1.26Z",
    className: "patternColor"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M462.98,265.44v-39.61h1.25v39.73c-.42-.04-.83-.08-1.25-.12Z",
    className: "patternColor"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M379.73,671.24c-2.71-1.33-3.37-22.86,0-28.6v28.6Z",
    className: "patternColor"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M539.98,238.53v-39.69h1.12v39.69h-1.12Z",
    className: "patternColor"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M439.93,239.21v-40.37c.32,0,.64,0,.96,0v40.38h-.96Z",
    className: "patternColor"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M247.99,239.23v-40.38c.28,0,.56-.02.83-.03v40.4c-.28,0-.56,0-.83.02h0Z",
    className: "patternColor"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M247.99,392.21v-40.37h.96v40.37h-.96Z",
    className: "patternColor"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M540.17,392.21v-40.18h1v40.17h-1Z",
    className: "patternColor"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M249,505.84v40.38h-.94v-40.38h.94Z",
    className: "patternColor"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M272.42,225.83v39.62c-2.12-1.76-2.91-32.06,0-39.62h0Z",
    className: "patternColor"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M541.04,505.84v40.38l-.78.03v-40.39c.26,0,.52-.01.78-.02h0Z",
    className: "patternColor"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M324.76,465.27v-36.48c.43,0,.87,0,1.3-.01v36.31c-.43.06-.87.12-1.3.18h0Z",
    className: "patternColor"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M357.13,131.9c1.46,12.66.6,24.4-1.94,26.3-1.94-9.75-.84-24.71,1.94-26.3Z",
    className: "patternColor"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M518.17,582.87v36.36c-.44,0-.87.01-1.31.02v-36.45c.44.02.87.05,1.31.07Z",
    className: "patternColor"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M326.17,582.87v36.35c-.44,0-.88.01-1.32.02v-36.45c.44.03.88.05,1.32.08Z",
    className: "patternColor"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M324.51,311.75v-36.41h1.27v36.63c-.42-.07-.85-.14-1.27-.2v-.02Z",
    className: "patternColor"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M517.92,275.33v36.63h-1.27v-36.63h1.27Z",
    className: "patternColor"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M248.22,598.3v-38.45l.71-.04v38.57c-.24-.03-.47-.05-.71-.08Z",
    className: "patternColor"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M564.45,378.81c.86,11.38.64,22.73-.3,34.07-.41-.01-.82-.02-1.23-.03v-34.03h1.53,0Z",
    className: "patternColor"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M463.32,573.2v-38.16c.38.01.76.03,1.14.04v38.14c-.38,0-.76-.01-1.14-.02Z",
    className: "patternColor"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M171.32,573.17v-34.43c.39,0,.78.02,1.18.03v34.52c-.39-.04-.78-.08-1.18-.13h0Z",
    className: "patternColor"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M262.99,554.65c-1.38-12.08-.69-24.05,1.41-25.94,2.15,5.16,1.46,23.21-1.41,25.94Z",
    className: "patternColor"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M224.71,312.28v-36.56c.42,0,.84,0,1.27-.01v36.44c-.42.05-.84.09-1.27.14h0Z",
    className: "patternColor"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M416.73,312.33v-36.6c.41,0,.83,0,1.24-.01v36.46c-.41.05-.83.11-1.24.16h0Z",
    className: "patternColor"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M554.76,554.17v-25.24c.47-.12.94-.25,1.41-.37.44,1.84,1.32,3.69,1.24,5.5-.32,6.75,1.16,13.76-.83,20.31-.61-.07-1.21-.14-1.82-.21h0Z",
    className: "patternColor"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M234.44,359.25c-.1,9.01.5,17.5-.89,25.93-3.08-4.37-2.52-23.46.89-25.93Z",
    className: "patternColor"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M224.77,465.19v-36.41h1.24v36.47c-.41-.02-.82-.03-1.24-.05h0Z",
    className: "patternColor"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M454.94,182.18c3.58,3.78,3.41,23.51,0,26.35v-26.35Z",
    className: "patternColor"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M355.13,208.75v-26.42c3.24,3.67,3.16,22.96,0,26.42Z",
    className: "patternColor"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M262.81,208.62v-25.9c3.66,2.38,3.87,22.72,0,25.9Z",
    className: "patternColor"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M523.53,513.44c3.47,1.68,4.15,20.81.97,25.18-1.47-8.23-.64-16.55-.97-25.18h0Z",
    className: "patternColor"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M531.83,201.08v-26.28c1.08.89,2.32,1.38,2.54,2.16,1.33,4.61-.1,21.44-2.54,24.11h0Z",
    className: "patternColor"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M265.16,490.11v25.32c-3.41-1.64-3.74-22.19,0-25.32Z",
    className: "patternColor"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M556.98,515.37c-3.26-1.63-3.54-22.2,0-25.06v25.06Z",
    className: "patternColor"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M455.1,221.73c3.2,1.5,3.55,22.03,0,25.07v-25.07h0Z",
    className: "patternColor"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M555.32,373.63c3.29,5.6,2.67,24.39,0,26.51v-26.51Z",
    className: "patternColor"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M262.74,400.6c-.26-8.85-.17-17.29.55-25.72,3.35,4.47,2.71,23.3-.55,25.72Z",
    className: "patternColor"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M354.93,221.12c3.64,3.11,3.37,22.99,0,25.41v-25.41Z",
    className: "patternColor"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M526.49,359.39c-.21,8.92.53,17.38-.98,25.77-3.11-4.51-2.43-23.2.98-25.77Z",
    className: "patternColor"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M495.13,262.6c-3.66-4.35-3.54-23.29,0-25.88v25.88Z",
    className: "patternColor"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M263.11,221.74c3.18,1.46,3.56,21.97,0,25.07v-25.07h0Z",
    className: "patternColor"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M555.31,336.85c2.73,2.17,3.3,21.04,0,26.53v-26.53Z",
    className: "patternColor"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M263.29,362.23v-25.26c.49-.62.99-1.24,1.48-1.86.21,1.12.6,2.24.61,3.36.05,7.92.03,15.85.03,23.77-.7,0-1.41,0-2.11-.01h-.01Z",
    className: "patternColor"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M556.06,221.38c.48,1.01,1.29,1.99,1.38,3.03,1.05,12.44.21,20.27-2.53,22.07v-24.7c.39-.13.77-.27,1.16-.4h0Z",
    className: "patternColor"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M333.93,206.04v25.19c-2.86-2.12-3.54-20.83,0-25.19Z",
    className: "patternColor"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M425.74,204.63v26.53c-2.69-2.17-3.29-20.96,0-26.53Z",
    className: "patternColor"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M525.78,231.26c-2.79-2.45-3.29-21.37,0-26.48v26.48Z",
    className: "patternColor"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M395.05,262.61c-3.51-4.04-3.37-22.51,0-26v26Z",
    className: "patternColor"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M303.13,262.6c-3.65-4.32-3.54-23.28,0-25.89v25.89Z",
    className: "patternColor"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M233.97,538.35c-3.22-1.55-3.54-22.09,0-25.06v25.06Z",
    className: "patternColor"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M586.09,265.85v-24.81c2.93,1.56,3.7,19.55,0,24.81Z",
    className: "patternColor"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M294.08,548.17c3.45,4.84,3,22.58,0,25.29v-25.29Z",
    className: "patternColor"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M486.17,573.18v-26.07c3.46,5.58,3.02,23.88,0,26.07Z",
    className: "patternColor"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M418.14,582.84v36.38c-.33,0-.67.02-1,.03v-36.39c.33,0,.67-.01,1-.02Z",
    className: "patternColor"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M449.26,321.04v25.66c-3.51-3.18-3.84-21.62,0-25.66Z",
    className: "patternColor"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M618.16,582.84v36.38c-.35,0-.7.02-1.05.02v-36.39c.35,0,.7,0,1.05-.01Z",
    className: "patternColor"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M386.04,265.76v-25.64c1.03,1.12,2.31,1.86,2.28,2.57-.25,7.79,1.3,15.71-.88,23.38-.47-.1-.94-.21-1.41-.31h.01Z",
    className: "patternColor"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M557.2,466.01c-2.61-2.24-3.65-13.65-2.55-22.1.15-1.11,1.26-2.09,2.55-4.11v26.21Z",
    className: "patternColor"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M303.21,390.68v24.47c-3.7-2.29-3.87-21.75,0-24.47Z",
    className: "patternColor"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M495.24,390v25.22c-3.45-2.3-3.92-20.96,0-25.22Z",
    className: "patternColor"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M293.93,394.12c3.58,3.74,3.38,22.51,0,25.4v-25.4Z",
    className: "patternColor"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M485.78,419.96v-25.08c3.53,1.67,3.97,21.03,0,25.08Z",
    className: "patternColor"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M485.92,265.89v-25.33c3.4,2.98,3.6,21.56,0,25.33Z",
    className: "patternColor"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M595.22,543.81v25.36c-3.43-1.88-3.92-20.19,0-25.36Z",
    className: "patternColor"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M495.18,570.08c-3.69-4.53-3.41-22.89,0-25.46v25.46Z",
    className: "patternColor"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M303.31,544.21v24.97c-3.6-2.13-4-21.2,0-24.97Z",
    className: "patternColor"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M203.23,543.83v25.35c-3.44-1.9-3.93-20.23,0-25.35Z",
    className: "patternColor"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M293.88,239.96c3.7,4.39,3.4,22.91,0,25.48v-25.48h0Z",
    className: "patternColor"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M193.99,573.41v-25.49c3.55,3.76,3.41,22.18,0,25.49Z",
    className: "patternColor"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M234.25,231.66c-3.85-3.37-3.65-21.42,0-24.49v24.49Z",
    className: "patternColor"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M355.27,643.04c3.39,5.75,2.72,22.92-.67,24.54.22-7.93-.6-15.59.67-24.54Z",
    className: "patternColor"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M454.79,158.69v-22.94c3.64,2.24,3.89,19.52,0,22.94Z",
    className: "patternColor"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M311.13,651.16c-3.67-3.9-3.34-20.79,0-22.58v22.58Z",
    className: "patternColor"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M403.06,628.41c1.31,11.05.71,20.03-1.38,21.95-2.12-4.93-1.49-19.17,1.38-21.95Z",
    className: "patternColor"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M287.79,596.29c-2.5-1.3-3.36-14.46-1.38-21.29,2.37,2.07,3.13,13.86,1.38,21.29Z",
    className: "patternColor"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M478.25,573.79c3.38,5.13,2.89,21.01,0,22.52v-22.52Z",
    className: "patternColor"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M509.1,159.3c3.16,2.95,3.47,18.25,0,22.64v-22.64Z",
    className: "patternColor"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M316.77,285.92v-22.03c3.56,1.85,3.99,18.07,0,22.03Z",
    className: "patternColor"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M500.64,166.83c3.4,2.97,3.75,18.2.71,22.32-.9-7.08-.77-14.21-.71-22.32h0Z",
    className: "patternColor"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M210.88,239.79c.54,7.49.76,14.97.46,22.42-.91-.05-1.82-.09-2.73-.14.45-7.44-1.46-15.01,2.27-22.28h0Z",
    className: "patternColor"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M402.87,189.03c-3.25-4.19-2.82-19.35,0-21.63v21.63Z",
    className: "patternColor"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M602.78,496.31c-2.84-1.68-3.33-17.4,0-22.5v22.5Z",
    className: "patternColor"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M310.75,189.24c-3.32-5.8-2.55-20.12,0-21.46v21.46h0Z",
    className: "patternColor"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M408.79,285.98v-22.03c3.52,1.7,3.98,17.93,0,22.03Z",
    className: "patternColor"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M502.88,474.97v21.22c-2.78-1.02-3.56-16.36,0-21.22Z",
    className: "patternColor"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M210.81,473.97v22.42c-2.88-1.85-3.29-17.71,0-22.42Z",
    className: "patternColor"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M379.72,596.21c-2.69-1.27-3.34-16.82,0-22.68v22.68Z",
    className: "patternColor"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M579.86,289.06c-3.26-4.36-2.79-19.46,0-21.6v21.6Z",
    className: "patternColor"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M572.31,451.17v22.04c-3.6-1.95-3.98-18.19,0-22.04Z",
    className: "patternColor"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M293.92,623.54v-21.93c3.57,2.84,3.6,18.39,0,21.93Z",
    className: "patternColor"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M485.93,601.66c3.53,2.69,3.6,18.24,0,21.9v-21.9Z",
    className: "patternColor"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M385.91,209.65v-23.04c3.21,2.57,3.56,17.2,0,23.04Z",
    className: "patternColor"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M180.31,605.9v21.23c-.46.13-.93.27-1.39.4-.45-1.68-1.36-3.38-1.25-5.02.39-5.59-1.46-11.55,1.21-16.8.48.06.95.13,1.43.19Z",
    className: "patternColor"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M280.15,605.07v22.41c-3.4-2.73-3.64-18.42,0-22.41Z",
    className: "patternColor"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M531.91,281.43v-21.7c3.59,2.49,3.68,18.84,0,21.7Z",
    className: "patternColor"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M477.63,266.88c3.4,2.88,3.78,18.08.73,22.26-.91-7.08-.76-14.2-.73-22.26Z",
    className: "patternColor"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M431.79,281.96v-22.03c3.54,1.75,3.98,17.98,0,22.03Z",
    className: "patternColor"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M377.55,266.88c3.46,2.79,3.88,17.95,1.04,22.22-1.61-7.02-.76-14.17-1.04-22.22Z",
    className: "patternColor"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M372.27,605.08v22.03c-3.52-1.7-3.98-17.93,0-22.03Z",
    className: "patternColor"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M287.85,267.47v22.37c-3.21-4.04-2.99-20.11,0-22.37Z",
    className: "patternColor"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M239.91,281.99v-22.41c3.4,2.73,3.64,18.42,0,22.41Z",
    className: "patternColor"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M509.04,263.62c3.31,2.87,3.46,18.53,0,22.12v-22.12Z",
    className: "patternColor"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M280.2,213.22c-3.75-4.71-3.4-20.13,0-22.56v22.56Z",
    className: "patternColor"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M472.16,627.31c-3.6-2.43-3.7-18.79,0-21.72v21.72Z",
    className: "patternColor"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M372.18,212.37c-3.67-2.6-3.71-18.95,0-21.74v21.74Z",
    className: "patternColor"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M585.92,340.15c3.59,3.84,3.4,19.39,0,22.36v-22.36Z",
    className: "patternColor"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M472.09,212.68c-3.49-3.6-3.46-19.05,0-22.21v22.21Z",
    className: "patternColor"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M186.18,596.69v-22.41c3.21,3.73,3.08,19.86,0,22.41Z",
    className: "patternColor"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M216.87,263.67c3.69,2.66,3.71,19.01,0,21.75v-21.75Z",
    className: "patternColor"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M477.9,441.83v-20.21c2.01.96,2.86,6.67,2.54,17.14-.04,1.3-.72,2.59-1.11,3.88-.48-.27-.96-.54-1.43-.81h0Z",
    className: "patternColor"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M509.31,592.16v-22.53c3.26,5.48,2.7,20.33,0,22.53Z",
    className: "patternColor"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M317.31,569.7c3.26,5.37,2.72,20.25,0,22.47v-22.47Z",
    className: "patternColor"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M632.01,567.28c3.45,2.73,3.35,18.83,0,21.35v-21.35Z",
    className: "patternColor"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M533.96,588.34c-3.22-1.55-3.53-18.1,0-21.06v21.06Z",
    className: "patternColor"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M432.13,588.67c-1.48-9.36-.82-19.15,1.31-20.96,2.02,5.27,1.43,18.61-1.31,20.96Z",
    className: "patternColor"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M279.49,298.55c1.56,6.84.76,13.8.99,21.17-3.38-2.2-4.03-16.67-.99-21.17Z",
    className: "patternColor"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M471.92,165.97c-3.36-4.3-2.86-18.68,0-21.35v21.35Z",
    className: "patternColor"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M471.82,319.58c-2.92-2.67-3.19-17.75,0-21.88v21.88Z",
    className: "patternColor"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M393.7,600.26c-1.75-7.17-1.62-14.32-.28-21.48.51,0,1.03,0,1.54-.01v21.38c-.42.04-.84.07-1.26.11Z",
    className: "patternColor"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M571.81,496.93v22.01c-2.82-1.5-3.54-16.88,0-22.01h0Z",
    className: "patternColor"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M279.86,498.01v21.09c-2.75-1.79-3.53-16.25,0-21.09Z",
    className: "patternColor"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M386.08,647.62c3.21,3.03,3.4,17.59,0,22.35v-22.35Z",
    className: "patternColor"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M385.85,624.44v-22.46c3.41,1.68,3.91,16.37,0,22.46Z",
    className: "patternColor"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M577.91,442.88v-21.28c3.44,1.72,3.71,18.3,0,21.28Z",
    className: "patternColor"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M288.18,421.03v21.38c-3.39-1.54-3.76-18.08,0-21.38Z",
    className: "patternColor"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M532.33,436.46v-22.53c2.68,2.1,3.28,16.9,0,22.53Z",
    className: "patternColor"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M472.13,344.23v21.31c-3.45-2.44-3.62-18.08,0-21.31Z",
    className: "patternColor"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M280.01,365.44c-3.33-2.33-3.51-17.96,0-21.13v21.13Z",
    className: "patternColor"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M486.05,340.44c3.28,3.21,3.35,17.99,0,22.42v-22.42Z",
    className: "patternColor"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M294.04,340.38c3.32,3.34,3.35,18.12,0,22.43v-22.43Z",
    className: "patternColor"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M602.92,342.76c-3.17-2.69-3.23-18.54,0-21.65v21.65Z",
    className: "patternColor"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M500.62,343.03c-.02-7.73-.18-14.6,1.09-21.35,2.77,7,2.05,18.98-1.09,21.35Z",
    className: "patternColor"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M209.08,321c3.3,3.31,3.19,19.16,0,21.76v-21.76Z",
    className: "patternColor"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M308.93,321.25c3.65,2.81,3.44,19.42,0,21.23v-21.23Z",
    className: "patternColor"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M485.99,315.48v-20.82c3.13,2.46,3.57,16.72,0,20.82Z",
    className: "patternColor"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M257.29,183.28v21c-3.94-2.38-3.87-18.15,0-21Z",
    className: "patternColor"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M303.12,600.63c-3.6-4.34-3.52-19.38,0-21.92v21.92Z",
    className: "patternColor"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M409.22,592.66v-22.73c3.15,5.29,2.96,19.47,0,22.73Z",
    className: "patternColor"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M495.14,600.5c-3.55-3.95-3.58-19.08,0-21.94v21.94Z",
    className: "patternColor"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M293.76,209.02v-22.23c3.59,2.57,3.93,17.59,0,22.23Z",
    className: "patternColor"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M387.63,140.77c1.27,7.18,1.44,14.35-.09,21.52-.47,0-.95,0-1.42.02v-21.43c.5-.04,1.01-.08,1.51-.11Z",
    className: "patternColor"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M371.73,297.18v21.96c-2.69-2.09-3.3-16.43,0-21.96Z",
    className: "patternColor"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M371.92,144.7v22.01c-3.37-4.49-3.09-19.35,0-22.01Z",
    className: "patternColor"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M609.07,592.65v-22c3.34,4.06,3.27,18.71,0,22Z",
    className: "patternColor"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M495.18,424.62v21.66c-3.33-2.13-3.78-17.32,0-21.66Z",
    className: "patternColor"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M303.08,424.19v21.84c-3.09-1.51-3.78-16.41,0-21.84Z",
    className: "patternColor"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M571.18,344.79c2.35,9.95,1.57,19.19-1.62,20.88.35-7.27-.84-14.2,1.62-20.88Z",
    className: "patternColor"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M485.96,186.1c3.48,4.46,3.36,18.83,0,22.54v-22.54Z",
    className: "patternColor"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M317.68,417.83c2.55,6.66,1.47,13.58.74,20.5-2.86-6.61-1.37-13.59-.74-20.5Z",
    className: "patternColor"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M508.9,438.44v-20.72c3.65,2.53,3.74,18.93,0,20.72Z",
    className: "patternColor"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M571.77,297.35v21.51c-2.7-1.28-3.51-16.19,0-21.51Z",
    className: "patternColor"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M293.89,316.59v-21.72c3.3,1.87,3.83,16.69,0,21.72Z",
    className: "patternColor"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M193.75,315.86v-21.04c3.61,2.01,3.97,17.26,0,21.04Z",
    className: "patternColor"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M418.02,128.82v29.46c-.37,0-.74,0-1.11,0v-29.46c.37,0,.74-.01,1.11-.02h0Z",
    className: "patternColor"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M585.9,515.33v-20.73c3.7,2.88,3.61,18.26,0,20.73Z",
    className: "patternColor"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M485.94,494.23c3.54,3.67,3.4,18.35,0,21.34v-21.34h0Z",
    className: "patternColor"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M293.89,516.13v-21.52c3.38,2.62,3.67,17.3,0,21.52Z",
    className: "patternColor"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M193.98,494.37c3.45,3.34,3.42,18.06,0,21.24v-21.24h0Z",
    className: "patternColor"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M585.77,315.91v-21.03c3.57,1.87,3.97,17.12,0,21.03Z",
    className: "patternColor"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M586.25,469.42v-22.62c3.18,5.38,2.86,18.96,0,22.62Z",
    className: "patternColor"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M495.16,270.49v21.82c-3.33-2.16-3.75-15.99,0-21.82Z",
    className: "patternColor"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M302.87,292.55c-2.99-2.98-3.21-16.39,0-21.85v21.85Z",
    className: "patternColor"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M595.25,270.99v21.19c-3.47-2.58-3.93-16.82,0-21.19Z",
    className: "patternColor"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M203.28,271.08v21.2c-3.55-2.84-3.91-17.1,0-21.2Z",
    className: "patternColor"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M395.13,292.6c-3.62-4.15-3.52-18.26,0-20.88v20.88Z",
    className: "patternColor"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M456.61,356.5c-3.79-6.23-1.04-13.1-2.33-20.32,3.44,2.41,4.16,9.79,2.33,20.32Z",
    className: "patternColor"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M455.25,663.75v-20.76c3.44,4.9,2.84,19.02,0,20.76Z",
    className: "patternColor"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M200.78,598c.07-6.43-1.11-12.92,1.91-19.17v19.35c-.64-.06-1.27-.12-1.91-.17h0Z",
    className: "patternColor"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M240.12,567.26c3.21,2.79,3.23,16.65,0,19.6v-19.6Z",
    className: "patternColor"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M540.88,405.86v27.94c-.31,0-.63-.01-.94-.02v-27.93c.31,0,.63,0,.94.01h0Z",
    className: "patternColor"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M609.04,322.14v-31.38l.99.02v31.33l-.99.03h0Z",
    className: "patternColor"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M316.89,463.43v-18.74c3.65,2.54,3.72,16.98,0,18.74Z",
    className: "patternColor"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M372.27,651.09v19.03c-3.53-1.73-3.95-14.98,0-19.03Z",
    className: "patternColor"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M348.99,158.43c-2.79-2.4-2.78-23.3,0-24.78v24.78Z",
    className: "patternColor"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M308.9,495.83v-17.21c2.94,1.4,2.97,1.41,2.54,14.15-.04,1.3-.72,2.57-1.1,3.86-.48-.27-.96-.53-1.44-.8Z",
    className: "patternColor"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M426.15,200.91c-3.63-3.01-3.38-15.63,0-18.28v18.28Z",
    className: "patternColor"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M624.35,634.9v-17.58c.49,0,.97.01,1.46.02v17.7c-.49-.05-.97-.09-1.46-.14Z",
    className: "patternColor"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M425.77,617.4v17.72h-1.46v-17.71c.49,0,.97-.01,1.46-.02h0Z",
    className: "patternColor"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M264.86,423.28c-2.6-1.2-3.19-6.57-1.93-17.38,2.82,1.61,3.65,9.1,1.93,17.38Z",
    className: "patternColor"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M332.16,635v-17.93c2.87,2.17,3.29,13.83,0,17.93Z",
    className: "patternColor"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M531.98,228.59c3.53,3.11,3.46,16.02,0,17.87v-17.87Z",
    className: "patternColor"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M526.09,336.77v17.8c-3.65-2.59-3.47-15.39,0-17.8Z",
    className: "patternColor"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M234.04,354.63c-2.75-2.38-3.38-9.64-1.92-17.81,2.67,1.06,3.3,6.65,1.92,17.81Z",
    className: "patternColor"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M334.15,354.46c-3.6-2.14-3.62-14.93,0-17.89v17.89Z",
    className: "patternColor"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M588.63,569.34c-4.29-7.5-3.03-14.33-2.02-21.15,2.82,6.49,1.41,13.34,2.02,21.15Z",
    className: "patternColor"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M472.17,551.7v17.75c-3.69-2.83-3.62-15.22,0-17.75Z",
    className: "patternColor"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M334.03,200.61c-3.34-3.12-3.39-14.86,0-18.17v18.17Z",
    className: "patternColor"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M372.16,217.58v17.73c-3.58-2.41-3.69-14.8,0-17.73Z",
    className: "patternColor"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M572.13,262.88c-3.57-3.75-3.41-15.46,0-18.34v18.34Z",
    className: "patternColor"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M280.15,551.07v18.41c-3.39-2.72-3.61-14.46,0-18.41Z",
    className: "patternColor"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M180.11,569.73c-3.51-3.43-3.43-14.95,0-18.24v18.24Z",
    className: "patternColor"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M180.16,578.75v17.73c-3.68-2.92-3.58-15.31,0-17.73Z",
    className: "patternColor"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M472.16,262.31c-3.59-2.42-3.69-14.8,0-17.72v17.72Z",
    className: "patternColor"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M239.88,382.69c3.65,2.58,3.69,14.96,0,17.74v-17.74Z",
    className: "patternColor"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M532,382.45c3.4,3.19,3.42,14.94,0,18.2v-18.2Z",
    className: "patternColor"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M257.06,231.61c-3.41-3.21-3.42-14.92,0-18.19v18.19Z",
    className: "patternColor"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M280.17,217.69v17.75c-3.69-2.83-3.62-15.22,0-17.75Z",
    className: "patternColor"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M264.75,578.36c-3.28-5.37-2.77-17.14,0-18.58v18.58Z",
    className: "patternColor"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M280.15,578.56v17.89c-3.58-3.15-3.61-14.57,0-17.89Z",
    className: "patternColor"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M256.72,386.48c-3.01-5.29-2.73-16.59,0-19.08v19.08Z",
    className: "patternColor"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M264.86,251.99v17.19c-2.76-.97-3.5-12.33,0-17.19h0Z",
    className: "patternColor"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M356.31,251.27c2.34,6.31.54,12.21,1.29,18.33-3.54-1.59-4.17-13.2-1.29-18.33Z",
    className: "patternColor"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M455.31,269.27v-18.63c3.28,5.46,2.76,17.2,0,18.63Z",
    className: "patternColor"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M354.79,577.97v-18.08c3.53,1.65,3.93,14.08,0,18.08Z",
    className: "patternColor"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M525.9,463.36v18.36c-3.2-3.69-3.1-15.82,0-18.36h0Z",
    className: "patternColor"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M233.78,482.27c-3.25-5.05-2.8-16.93,0-18.54v18.54Z",
    className: "patternColor"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M180.17,542.4c-3.63-2.38-3.66-14.94,0-17.8v17.8Z",
    className: "patternColor"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M331.54,173.58c.46-6.11-.94-11.98,1.19-18.36,2.9,5.17,2.28,16.78-1.19,18.36Z",
    className: "patternColor"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M280.15,524.08v18.4c-3.39-2.73-3.61-14.44,0-18.4Z",
    className: "patternColor"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M472.3,524.16v18.04c-3.59-1.91-3.96-14.17,0-18.04Z",
    className: "patternColor"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M455.35,578.5v-18.65c2.66,1.22,3.28,12.84,0,18.65Z",
    className: "patternColor"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M556.75,269.27c-2.75-1.42-3.28-13.15,0-18.62v18.62Z",
    className: "patternColor"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M424.31,173.27v-18.63c3.28,5.46,2.75,17.2,0,18.63Z",
    className: "patternColor"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M554.89,577.47v-17.8c3.63,2.4,3.67,14.92,0,17.8Z",
    className: "patternColor"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M372.13,596.89c-3.57-3.75-3.41-15.48,0-18.35v18.35Z",
    className: "patternColor"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M526.12,427.83c-3.54-3.64-3.41-15.35,0-18.31v18.31Z",
    className: "patternColor"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M526.18,327.38c-3.65-2.6-3.69-14.99,0-17.75v17.75Z",
    className: "patternColor"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M449.15,213.58v17.72c-3.57-2.38-3.69-14.76,0-17.72Z",
    className: "patternColor"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M333.75,563.79v18.63c-3.28-5.46-2.75-17.2,0-18.63Z",
    className: "patternColor"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M572.28,524.11v18.02c-.29.17-.58.34-.87.51-.6-.85-1.57-1.63-1.74-2.56-1.07-5.59,0-13.33,2.61-15.97h0Z",
    className: "patternColor"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M525.86,563.45v18.34c-3.2-3.92-3.01-16.02,0-18.34Z",
    className: "patternColor"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M625.76,582.35c-3.28-5.36-2.77-17.14,0-18.57v18.57Z",
    className: "patternColor"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M572.27,217.08v18.03c-3.51-1.71-3.94-13.99,0-18.03Z",
    className: "patternColor"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M424.21,661.59v-18.37c3.2,4.02,3,16.11,0,18.37Z",
    className: "patternColor"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M334.26,309.41v17.92c-3.64-2.3-3.84-14.64,0-17.92Z",
    className: "patternColor"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M472.01,235.43c-3.3-2.8-3.45-14.52,0-18.12v18.12Z",
    className: "patternColor"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M233.74,490.8v18.63c-3.28-5.56-2.73-17.27,0-18.63Z",
    className: "patternColor"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M303.19,601.64v17.75c-3.66-2.64-3.67-15.02,0-17.75Z",
    className: "patternColor"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M233.88,256v17.19c-2.79-1.15-3.51-12.53,0-17.19Z",
    className: "patternColor"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M446.34,585.57c3.7,3.22,4.02,14.5,1.45,19.23-2.42-6.31-.54-12.22-1.45-19.23Z",
    className: "patternColor"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M372.16,262.31c-3.59-2.42-3.69-14.81,0-17.72v17.72Z",
    className: "patternColor"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M495.16,619.47c-3.67-2.93-3.57-15.31,0-17.72v17.72Z",
    className: "patternColor"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M280.18,244.64v17.75c-3.67-2.63-3.69-15.02,0-17.75h0Z",
    className: "patternColor"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M532,536.36c3.42,3.15,3.39,15.02,0,18.28v-18.28Z",
    className: "patternColor"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M239.94,536.24c3.53,3.63,3.41,15.34,0,18.31v-18.31Z",
    className: "patternColor"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M395.13,619.89c-3.56-3.75-3.4-15.48,0-18.35v18.35Z",
    className: "patternColor"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M256.89,586.37v18.35c-3.19-3.72-3.07-15.82,0-18.35Z",
    className: "patternColor"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M525.72,509.47c-3.29-5.72-2.69-17.36,0-18.63v18.63Z",
    className: "patternColor"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M526.14,182.64v17.71c-3.55-2.43-3.65-14.84,0-17.71h0Z",
    className: "patternColor"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M472.27,578.12v18.19c-3.57-2.52-3.85-13.94,0-18.19Z",
    className: "patternColor"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M549.27,213.37v17.93c-3.64-2.24-3.86-14.57,0-17.93Z",
    className: "patternColor"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M426.59,274.15c-3.54-2.78-3.97-13.87-1.28-19.02,2.18,6.45.7,12.31,1.28,19.02Z",
    className: "patternColor"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M234.16,327.47c-3.65-2.87-3.61-15.51,0-17.82v17.82Z",
    className: "patternColor"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M571.93,271.79v17.82c-3.45-4.13-3.12-15.72,0-17.82Z",
    className: "patternColor"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M572.12,388.79c-3.57-3.08-3.44-14.78,0-17.28v17.28Z",
    className: "patternColor"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M333.9,256.03v17.2c-2.83-1.96-3.44-12.81,0-17.2h0Z",
    className: "patternColor"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M495.05,294.71v17.4c-3.54-3.12-3.36-14.87,0-17.4Z",
    className: "patternColor"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M470.29,425.08c3.28,5.11,2.6,15.83,0,17.2v-17.2Z",
    className: "patternColor"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M548.73,296.14c-2.71-2.13-3.24-12.98,0-18.53v18.53Z",
    className: "patternColor"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M280.4,425.28c-.07,5.71.61,11.47-.44,17.13-.54-.03-1.09-.06-1.63-.09v-17.39c.69.12,1.38.23,2.07.35h0Z",
    className: "patternColor"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M525.96,256.12v16.86c-2.94-1.31-3.67-12.67,0-16.86h0Z",
    className: "patternColor"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M333.76,642.69v18.16c-2.7-1.26-3.44-12.57,0-18.16Z",
    className: "patternColor"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M257.02,296.67c-2.89-2.89-3.37-13.18-1.23-17.62,1.94,2.29,2.42,8.52,1.23,17.62Z",
    className: "patternColor"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M279.93,415.75c-3.18-2.77-3.24-14.57,0-17.61v17.61h0Z",
    className: "patternColor"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M302.95,311.89c-3.29-4.35-2.92-14.58,0-17.38v17.38Z",
    className: "patternColor"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M448.86,279v17.09c-2.77-1.8-3.48-12.32,0-17.09Z",
    className: "patternColor"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M548.81,367.63v18.42c-3.19-4.49-2.88-15.66,0-18.42Z",
    className: "patternColor"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M432.16,246.21v-17.81c3.45,3.92,3.05,15.69,0,17.81Z",
    className: "patternColor"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M240.32,227.62c3.24,5.53,2.72,16.45,0,18.54v-18.54Z",
    className: "patternColor"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M511.54,471.14c-.57,5.84.95,11.74-1.54,17.19-2.61-7.66-1.71-15.75,1.54-17.19Z",
    className: "patternColor"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M371.86,271.49v18.45c-3.21-4.55-3-15.56,0-18.45Z",
    className: "patternColor"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M548.93,538.38c-3.15-1.7-3.44-13.63,0-17.25v17.25Z",
    className: "patternColor"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M257,538.34c-3.28-1.51-3.53-13.8,0-17.18v17.18Z",
    className: "patternColor"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M280.08,388.57c-3.47-2.55-3.49-14.06,0-17.15v17.15Z",
    className: "patternColor"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M471.94,288.53c-3.48-4.39-2.87-14.66,0-16.68v16.68Z",
    className: "patternColor"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M279.86,289.3c-3.22-3.91-3-14.78,0-17.78v17.78Z",
    className: "patternColor"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M572.16,425.7v16.74c-3.73-1.83-3.61-14.26,0-16.74Z",
    className: "patternColor"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M395.29,139.89v18.4c-3.62-2.31-3.88-12.6,0-18.4Z",
    className: "patternColor"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M201.47,311.93v-17.18h1.43v17.18h-1.43Z",
    className: "patternColor"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M362.95,154.27v-21.32c.41,0,.82-.03,1.24-.04v21.33l-1.24.03h0Z",
    className: "patternColor"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M594.93,294.63v18.09c-3.36-4.89-3.13-14.94,0-18.09Z",
    className: "patternColor"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M362.93,615.61v-20.99c2.68,2.27,2.85,17.93,0,20.99Z",
    className: "patternColor"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9,615.16v-20.49h1.32v20.63c-.44-.05-.88-.1-1.32-.15h0Z",
    className: "patternColor"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M563.23,461.83v-20.94c2.35,6.88,1.5,13.89,1.25,20.88-.42.02-.83.04-1.25.06Z",
    className: "patternColor"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M410.86,306.52c-4.19-4.89-1.24-10.47-1.31-15.8,2.84,4.98,1.44,10.46,1.31,15.8Z",
    className: "patternColor"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M564.44,286.78v21.46c-.45,0-.9.01-1.35.02v-21.4c.45-.03.9-.05,1.35-.08Z",
    className: "patternColor"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M549.6,587.29c-1.21,5.09,1.98,10.83-3.04,16.77.13-6.77-.27-12.21.25-17.53.93.26,1.86.51,2.79.77h0Z",
    className: "patternColor"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M362.87,308.23v-21.05c2.52,1.23,3.1,14.91,0,21.05Z",
    className: "patternColor"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M341.77,436.59v23.78h-1.42v-23.77h1.42Z",
    className: "patternColor"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M549.1,204.58c-2.97-2.71-3.06-3.4-2.33-16.06,3.19,1.86,3.56,4.27,2.33,16.06Z",
    className: "patternColor"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M324.77,212.22v-21.47c.4,0,.8,0,1.21-.02v21.48h-1.21Z",
    className: "patternColor"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M518.01,498.28v20.86c-.35.02-.7.04-1.04.06v-20.86c.35-.02.7-.04,1.04-.06Z",
    className: "patternColor"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M224.56,519.29v-21.01c.42-.02.84-.03,1.26-.05v20.91c-.42.05-.84.1-1.26.15Z",
    className: "patternColor"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M518.02,190.73v21.48c-.36,0-.73,0-1.09.02v-21.48c.36,0,.73,0,1.09-.02Z",
    className: "patternColor"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M440.06,154.22v-22.39h.96v22.38h-.96Z",
    className: "patternColor"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M216.22,438.17c.52-5.48,1.03-10.96,1.55-16.45l1.69.15c-.48,5.49,1.2,11.15-1.05,16.51-.73-.07-1.46-.14-2.19-.21Z",
    className: "patternColor"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M193.85,618.3v-16.63c3.77,2.68,3.67,9.86,0,16.63Z",
    className: "patternColor"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M272.31,594.32v20.96c-.31-.03-.63-.05-.94-.08v-20.96c.31.02.63.05.94.07h0Z",
    className: "patternColor"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M464.23,594.33v20.88c-.33-.02-.67-.04-1-.06v-20.88c.33.02.67.04,1,.06Z",
    className: "patternColor"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M271.05,308.24v-21.28c.44-.02.88-.04,1.32-.05.11,3.47.27,6.94.33,10.41.06,3.65.01,7.31.01,10.96-.55-.01-1.11-.03-1.66-.04Z",
    className: "patternColor"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M494.75,632.85c.28,5.19,1.93,10.51-1.21,15.39-.51-5.21-2.35-10.55,1.21-15.39Z",
    className: "patternColor"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M324.75,365.29v-20.55h1.29v20.55h-1.29Z",
    className: "patternColor"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M516.77,365.32v-20.52h1.34v20.35c-.45.06-.89.12-1.34.18h0Z",
    className: "patternColor"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M486.09,146.63c3.16,2.81,3.32,11.37,0,16.4v-16.4Z",
    className: "patternColor"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M462.96,308.21v-21.39c.42,0,.84,0,1.25-.01v21.39h-1.25Z",
    className: "patternColor"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M417.99,190.86v20.97h-1.23v-20.98c.41,0,.82,0,1.23,0Z",
    className: "patternColor"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M516.62,449.1v-20.32c.61.02,1.22.03,1.83.05-.13,6.77.56,13.56-.52,20.31-.44-.01-.88-.02-1.32-.04h.01Z",
    className: "patternColor"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M501.51,643.23c-1.73-9.88-1.28-13.27,2-14.74-.68,5.15,1.45,10.24-2,14.74Z",
    className: "patternColor"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M311.16,163.09c-3.62-4.16-3.36-12.89,0-15.5v15.5Z",
    className: "patternColor"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M555.14,420.55v-15.16c3.53,3.92,3.04,12.87,0,15.16Z",
    className: "patternColor"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M471.64,451.89c.04,4.87,2.39,9.94-1.19,14.37-.57-4.9-2.02-9.86,1.19-14.37Z",
    className: "patternColor"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M226.02,344.83v20.38c-.33,0-.67,0-1,.01v-20.38c.33,0,.67,0,1-.01Z",
    className: "patternColor"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M464.26,440.83v20.46c-.31.02-.63.03-.94.05v-20.47c.31-.01.63-.02.94-.03h0Z",
    className: "patternColor"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M288.17,554.96c-3.7-3.14-3.41-12.73,0-14.34v14.34Z",
    className: "patternColor"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M477.9,553.83v-14.46c4.16,4.04,2,8.05,2.5,11.42.18,1.2-.67,2.56-1.06,3.84l-1.44-.81h0Z",
    className: "patternColor"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M285.91,386.23c3.68,2.81,3.46,12.38,0,14.24v-14.24Z",
    className: "patternColor"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M480.44,386.84c-.09,4.55.51,9.18-1.53,13.52-1.49-4.73-1.46-9.29-1.09-13.81.87.1,1.75.19,2.62.29Z",
    className: "patternColor"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M579.99,473.4c-3.31-1.71-3.52-11.32,0-14.06v14.06Z",
    className: "patternColor"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M334.19,304.41c-3.67-2.68-3.68-12.13,0-13.77v13.77Z",
    className: "patternColor"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M234.17,305.5c-4.24-4.2-1.98-8.47-2.5-12.12-.13-.92.86-2,1.33-3l1.17.39v14.73h0Z",
    className: "patternColor"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M248.27,425.83v-19.98l.52-.06v20.02c-.17,0-.34.01-.52.02h0Z",
    className: "patternColor"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M424.21,290.77c2.61,1.26,3.08,4.71,1.83,13.43-2.74-1.52-3.38-6.22-1.83-13.43Z",
    className: "patternColor"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M526.17,290.11v14.35c-3.37-2.6-3.63-11.31,0-14.35Z",
    className: "patternColor"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M378.31,166v-14.14h1.46v14.19c-.49-.02-.97-.03-1.46-.05Z",
    className: "patternColor"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M426.63,137c-.2,4.5-.4,9-.6,13.5-.71-.07-1.42-.14-2.12-.21-.2-4.55-1.29-9.18.73-13.55.66.09,1.33.17,1.99.26h0Z",
    className: "patternColor"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M625.73,597.9v13.91c-.46,0-.93,0-1.39.01v-13.92c.46,0,.93,0,1.39-.01h0Z",
    className: "patternColor"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M418.05,651.82v19.25h-.83v-19.24c.28,0,.55-.01.83-.02h0Z",
    className: "patternColor"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M508.93,554.42v-13.87c3.6,2.21,3.54,11.07,0,13.87Z",
    className: "patternColor"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M580.64,233.01c-.2,4.5-.41,9-.61,13.5-.72-.07-1.43-.15-2.15-.22-.17-4.56-1.2-9.19.66-13.58l2.1.3h0Z",
    className: "patternColor"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8,554.18v-13.36c.86.2,2.27.36,2.28.56.17,4.36,1.63,8.92-.92,12.96l-1.36-.16h0Z",
    className: "patternColor"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M288,305.45v13.88c-3.27-1.5-3.51-10.37,0-13.88Z",
    className: "patternColor"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M525.77,597.98v14.19h-1.46v-14.12c.49-.02.97-.04,1.46-.07Z",
    className: "patternColor"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M185.42,554c.21-4.47.41-8.95.62-13.42.72.07,1.44.13,2.15.2.1,4.55,1.31,9.19-.8,13.55-.66-.11-1.32-.22-1.97-.33h0Z",
    className: "patternColor"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M479.59,306.04v13.42c-.4-.04-.8-.09-1.2-.13v-13.52c.4.08.8.15,1.2.23h0Z",
    className: "patternColor"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M425.85,598.03v14.47c-2.81-3.3-3.01-10.68,0-14.47Z",
    className: "patternColor"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M333.52,459.56c-3.2-5.58-1.36-10.23-1.99-14.91,3.23,1.15,3.88,6.02,1.99,14.91Z",
    className: "patternColor"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M234.16,444.69v13.75c-3.68-2.84-3.62-12.26,0-13.75Z",
    className: "patternColor"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M333.81,597.92v14.2h-1.45v-14.2h1.45Z",
    className: "patternColor"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M380.16,231.63v14.66l-1.17.39c-.47-1-1.46-2.08-1.33-3,.53-3.65-1.77-7.93,2.49-12.05h.01Z",
    className: "patternColor"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M510.7,198.85v14.71c-3.19-5.78-2.65-13.49,0-14.71Z",
    className: "patternColor"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M408.85,246.39v-13.45c3.66,2.29,3.81,10.75,0,13.45Z",
    className: "patternColor"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M193.86,336.08v-14.3c3.42,2.16,3.77,9.92,0,14.3Z",
    className: "patternColor"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M216.86,246.66v-14.03c3.56,3.08,3.67,10.72,0,14.03Z",
    className: "patternColor"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M293.93,167.16c3.55,3.74,3.4,11.51,0,14.36v-14.36Z",
    className: "patternColor"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M586.01,335.56v-13.86c3.34,2.6,3.49,10.46,0,13.86Z",
    className: "patternColor"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M486,461.71v-13.9c3.71,4.19,3.33,12.4,0,13.9Z",
    className: "patternColor"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M326.11,540.72v17.13c-2.29-1.91-2.79-12.11,0-17.13Z",
    className: "patternColor"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M409.2,198.67c2.98,2.06,3.24,9.05,0,14.62v-14.62Z",
    className: "patternColor"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M385.82,182.14v-14.26c3.46,2.16,3.82,9.67,0,14.26Z",
    className: "patternColor"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M479.72,231.57v14.65c-2.68-1.24-3.21-9.01,0-14.65Z",
    className: "patternColor"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M518.06,540.73v17.33c-.43,0-.85,0-1.28.01v-17.31l1.28-.04h0Z",
    className: "patternColor"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M608.76,554.89v-14.06c3.59,1.91,3.9,10.3,0,14.06Z",
    className: "patternColor"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M318.73,198.79v14.67c-3.2-5.44-2.74-13.26,0-14.67Z",
    className: "patternColor"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M631.76,638.83v-14.02c3.61,2.05,3.89,10.39,0,14.02Z",
    className: "patternColor"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M486.01,167.49c3.33,3.06,3.37,10.88,0,14.18v-14.18h0Z",
    className: "patternColor"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M580.61,320.17c-3.54-2.69-3.92-9.98-1.47-14.79,2.47,4.81.82,9.39,1.47,14.79Z",
    className: "patternColor"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M217.05,505.64c3.29,2.77,3.43,10.54,0,14.13v-14.13Z",
    className: "patternColor"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M303.06,647c-3.34-3.43-3.4-10.55,0-14.69v14.69Z",
    className: "patternColor"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M294.03,474.28c3.31,3.87,3.31,11.02,0,14.44v-14.44Z",
    className: "patternColor"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M316.98,505.37c3.41,3.29,3.38,11.11,0,14.24v-14.24h0Z",
    className: "patternColor"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M478.23,152.77c2.73,1.35,3.3,8.44,1.05,13.1-2.01-2.26-2.4-7.03-1.05-13.1Z",
    className: "patternColor"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M516.77,404.25v-17.51h1.23v17.47c-.41.02-.82.03-1.23.05h0Z",
    className: "patternColor"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M508.89,400.46v-13.77c3.59,2.42,3.65,10.93,0,13.77Z",
    className: "patternColor"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M316.89,246.45v-13.69c3.58,2.65,3.68,10.86,0,13.69Z",
    className: "patternColor"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M508.92,232.15c3.54,4.06,3.41,11.57,0,14.34v-14.34Z",
    className: "patternColor"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M317.11,365.44v-13.8c3.37,3.36,3.17,11.57,0,13.8Z",
    className: "patternColor"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M287.73,246.23c-2.71-1.28-3.22-9.08,0-14.63v14.63Z",
    className: "patternColor"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M316.8,400.68v-13.96c3.65,2.2,3.83,10.61,0,13.96Z",
    className: "patternColor"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M508.9,519.46v-13.75c3.58,2.46,3.65,10.91,0,13.75Z",
    className: "patternColor"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M186.33,613.83c2.71,1.28,3.22,9.09,0,14.63v-14.63Z",
    className: "patternColor"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M286.29,613.76c2.84,1.52,3.25,9.45,0,14.56v-14.56Z",
    className: "patternColor"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M379.88,613.34v14.36c-3.14-3.63-3.05-11.82,0-14.36Z",
    className: "patternColor"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M478.34,613.45c2.73,2.36,2.99,9.79,0,15.02v-15.02Z",
    className: "patternColor"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M572.85,551.98c-.48,4.76-.95,9.53-1.43,14.29-.61-.06-1.21-.12-1.82-.18.42-4.79-1.13-9.78,1.08-14.37.72.09,1.45.18,2.17.27h0Z",
    className: "patternColor"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M509.28,350.92c3.15,4.78,2.84,12.2,0,14.5v-14.5Z",
    className: "patternColor"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M608.82,519.58v-13.87c3.63,2.37,3.75,10.81,0,13.87Z",
    className: "patternColor"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M303.23,367.36v14.04c-3.56-3.42-3.7-10.66,0-14.04Z",
    className: "patternColor"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M495.03,381.79c-3.33-4.49-3.34-11.02,0-14.45v14.45Z",
    className: "patternColor"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M585.83,474.22c3.7,4.26,3.54,11.73,0,14.14v-14.14Z",
    className: "patternColor"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M217.19,365.17v-13.87c3.39,4.09,2.97,11.97,0,13.87Z",
    className: "patternColor"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M395.02,227.65c-3.29-3.29-3.33-10.2,0-14.43v14.43Z",
    className: "patternColor"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M495.15,213.51v13.92c-3.56-2.77-3.58-10.12,0-13.92Z",
    className: "patternColor"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M303.23,213.23v14.14c-3.55-2.43-3.7-9.79,0-14.14Z",
    className: "patternColor"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M485.92,628.46c3.61,4.23,3.55,11.31,0,13.9v-13.9Z",
    className: "patternColor"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M594.5,451.29c.41,4.62.82,9.24,1.23,13.86-.55.06-1.11.13-1.66.19-3.06-4.29-.68-9.34-1.58-13.93.67-.04,1.35-.08,2.02-.13h-.01Z",
    className: "patternColor"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M385.92,627.69c3.54,5.24,3.34,11.89,0,14.82v-14.82Z",
    className: "patternColor"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M293.9,336.41v-14.44c3.32,1.66,3.74,8.69,0,14.44Z",
    className: "patternColor"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M486.03,321.16c3.31,3.69,3.28,10.36,0,14.54v-14.54Z",
    className: "patternColor"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M518.14,232.84v17.34h-1.37v-17.34h1.37Z",
    className: "patternColor"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M202.94,534.91c-3.3-4.6-2.97-10.64,0-13.25v13.25Z",
    className: "patternColor"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M302.84,521.35v14.77c-3.07-5.14-2.94-11.5,0-14.77Z",
    className: "patternColor"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M494.88,535.94c-3.31-5.18-2.99-11.93,0-14.08v14.08Z",
    className: "patternColor"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M595,534.74c-3.26-3.9-3.11-10.12,0-13.47v13.47Z",
    className: "patternColor"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M385.8,307.63v-12.94c3.77,2.52,3.76,9.82,0,12.94Z",
    className: "patternColor"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M618.11,540.79v17.33l-1.19.03v-17.33c.4-.01.79-.02,1.19-.04h0Z",
    className: "patternColor"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M348.14,445.41c.42,6.6.84,13.19,1.32,20.7-5.39-3.12-1.1-6.83-1.78-9.82-.79-3.48-.74-7.15-1.05-10.73.5-.05,1-.1,1.51-.15h0Z",
    className: "patternColor"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M326.07,232.82v17.31h-1.21v-17.31h1.21Z",
    className: "patternColor"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M339.97,541.36c3.39,2.7,3.62,9.88,0,13.25v-13.25Z",
    className: "patternColor"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M408.79,672.97v-13.03c3.51,1.73,3.86,9.1,0,13.03Z",
    className: "patternColor"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M294.07,628.5c3.25,4.1,3.36,10.55,0,13.24v-13.24Z",
    className: "patternColor"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M593.42,262.25v-13.13c3.73,3.6,1.53,8.44,1.98,12.87-.66.09-1.32.18-1.98.26Z",
    className: "patternColor"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M341.86,136.91v16.27h-1.45v-16.43c.48.05.97.11,1.45.16Z",
    className: "patternColor"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M226.05,539.89v17.57c-2.19-2.48-2.52-12.7,0-17.57Z",
    className: "patternColor"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M425.74,568.89v13.52c-3.17-5.3-2.77-11.3,0-13.52Z",
    className: "patternColor"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M226.16,232.84v17.38c-.35,0-.69.02-1.04.02v-17.39c.35,0,.69,0,1.04,0h0Z",
    className: "patternColor"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M416.82,250.22v-17.39c.32,0,.63,0,.95,0v17.39c-.32,0-.63,0-.95-.02h0Z",
    className: "patternColor"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M395.21,127.21v12.02c-3.46-2.28-3.71-9.2,0-12.02Z",
    className: "patternColor"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M432.27,317.84c3.77,3.4,1.49,7.69,2.48,12.69-5.13-4.24-2.33-8.74-2.48-12.69Z",
    className: "patternColor"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M554.81,209.04v-12.69c3.45,2.42,3.83,8.59,0,12.69Z",
    className: "patternColor"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M333.98,150.41c-3.24-2.47-3.42-9.33,0-12.11v12.11Z",
    className: "patternColor"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M325.84,142.16v15.98c-.31.03-.63.06-.94.08v-16.05c.31,0,.63,0,.94,0Z",
    className: "patternColor"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M479.5,644.09v11.61c-.43-.02-.85-.04-1.28-.06v-11.69c.43.05.85.09,1.28.14Z",
    className: "patternColor"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M334.89,360.12c-.54,3.82-1.09,7.63-1.63,11.45l-1.59-.23c.33-3.89-1.46-8.06,1.39-11.62.61.13,1.22.27,1.84.4h-.01Z",
    className: "patternColor"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M564.32,482.76v13.56c-.36.03-.72.05-1.07.08v-13.57c.36-.02.72-.04,1.07-.06h0Z",
    className: "patternColor"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M462.92,154.23v-16.07c3.09,5.2,1.07,10.68,1.66,16.01-.55.02-1.1.04-1.66.06Z",
    className: "patternColor"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M193.31,488.12c.45-3.81.9-7.63,1.36-11.44.48.06.96.12,1.44.18.13,3.89,1.6,7.96-1.14,11.47-.55-.07-1.1-.14-1.65-.21h-.01Z",
    className: "patternColor"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M234.08,563.53c.19,3.89.38,7.78.57,11.66l-1.56.25c-.65-3.82-1.31-7.64-1.96-11.46l2.95-.45h0Z",
    className: "patternColor"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M362.88,650.18v-13.34c2.74,4.4,2.19,8.91,1.25,13.43-.42-.03-.83-.06-1.25-.09h0Z",
    className: "patternColor"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M426.29,309.83v11.04c-4.2-1.32-2.5-4.78-2.62-7.37-.06-1.34.84-2.73,1.31-4.1.44.14.87.29,1.31.43Z",
    className: "patternColor"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M564.48,328.83v13.47h-1.41v-13.44c.47-.01.94-.03,1.41-.04h0Z",
    className: "patternColor"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M492.42,459.96c.22-4.6.39-8.25.62-13.23,3.4,4.91,3.05,10.14-.62,13.23Z",
    className: "patternColor"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M455.3,554.24c-.09-3.75-2.43-7.96,2.2-11.81-.56,4.6,1.41,8.62-2.2,11.81Z",
    className: "patternColor"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M362.96,188.67v-12.79c.43-.02.86-.03,1.29-.05v12.98c-.43-.05-.86-.09-1.29-.14Z",
    className: "patternColor"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M564.29,355.8v13.44h-1.29v-13.44h1.29Z",
    className: "patternColor"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M248.87,446.25v14.95c-.23.02-.47.05-.7.07v-15.02h.7Z",
    className: "patternColor"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M464.47,636.84v13.46c-.45,0-.91,0-1.36.01v-13.46c.45,0,.91,0,1.36-.01Z",
    className: "patternColor"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M164.49,563.66c.26,4.64,2.47,9.52-.3,13.76-.55-.07-1.1-.15-1.64-.22.65-4.51,1.3-9.03,1.94-13.54h0Z",
    className: "patternColor"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M563.03,523.26v-13.44h1.24v13.44h-1.24Z",
    className: "patternColor"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M332.12,438.93c-.47-3.45-1.71-6.96,1.72-11.31v11.46c-.57-.05-1.15-.1-1.72-.14h0Z",
    className: "patternColor"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M234.13,240.76v9.46c-.39.14-.79.28-1.18.43-.46-1.1-1.29-2.2-1.29-3.3,0-2.3.44-4.6.69-6.89.59.1,1.19.21,1.78.31h0Z",
    className: "patternColor"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M525.89,439.02c-3.29-4.12-2.89-8.13,0-10.14v10.14Z",
    className: "patternColor"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M240.16,458.46v-10.89c3.22,3.44,3.08,7.95,0,10.89Z",
    className: "patternColor"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M303.46,448.31l-.48,10.14c-.79-.05-1.58-.11-2.38-.16.18-3.46.37-6.93.55-10.39l2.3.41h.01Z",
    className: "patternColor"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M423.41,250.14c.29-3.21.58-6.43.86-9.64.76.1,1.52.21,2.29.31-.2,3.23-.4,6.46-.59,9.69-.85-.12-1.7-.24-2.56-.36Z",
    className: "patternColor"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M271,496.29v-13.46c.42,0,.83,0,1.25-.01v13.44c-.42.01-.83.02-1.25.03Z",
    className: "patternColor"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M333.73,240.88c.31,3.29,1.92,6.76-.98,9.51-1.18-3.38-2.3-6.74.98-9.51Z",
    className: "patternColor"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M272.27,355.84v13.4h-1.24v-13.4h1.24Z",
    className: "patternColor"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M595.03,590.56c-1.45-4.03-4.3-7.67,0-12.93v12.93Z",
    className: "patternColor"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M426.17,582.58v9.76c-3.59-1.53-3.65-6.96,0-9.76Z",
    className: "patternColor"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M531.88,294.08c3.63,3.14,3.42,7.81,0,10.36v-10.36Z",
    className: "patternColor"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M232.34,285.16v-10.04l1.39.02v10.04c-.46,0-.93,0-1.39-.01h0Z",
    className: "patternColor"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M624.23,557.95v-9.97c.49,0,.97,0,1.46-.01v10.02c-.49-.01-.97-.03-1.46-.04h0Z",
    className: "patternColor"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9,342.17v-13.32c.42-.01.84-.02,1.26-.04v13.44c-.42-.03-.84-.05-1.26-.08Z",
    className: "patternColor"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M464.33,328.83v13.47h-1.26v-13.45c.42,0,.84-.01,1.26-.02Z",
    className: "patternColor"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M524.26,558.11v-10.19c.49,0,.97-.01,1.46-.02v10.06c-.49.05-.97.1-1.46.14h0Z",
    className: "patternColor"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M272.1,509.81v13.42h-1.08v-13.42h1.08Z",
    className: "patternColor"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M626.2,593.04c-3.66-3.28-3.42-7.95,0-10.41v10.41Z",
    className: "patternColor"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M431.88,611.43v-9.74c3.62,2.5,3.65,7.96,0,9.74Z",
    className: "patternColor"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M332.21,284.89v-9.91h1.46v10.21c-.49-.1-.97-.2-1.46-.3Z",
    className: "patternColor"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M425.74,275.16v10.02h-1.41v-10.02c.47,0,.94,0,1.41.01h0Z",
    className: "patternColor"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M531.91,611.46v-9.73c3.56,2.41,3.65,7.94,0,9.73Z",
    className: "patternColor"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M631.93,611.5v-9.68c3.51,2.16,3.68,7.59,0,9.68Z",
    className: "patternColor"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M524.32,285.19v-10.17h1.33v10.17h-1.33Z",
    className: "patternColor"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M523.3,249.79c.37-3.05.73-6.11,1.1-9.16.57.08,1.15.17,1.72.25.19,3.27,1.3,6.68-.59,9.62-.74-.24-1.49-.48-2.23-.72h0Z",
    className: "patternColor"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M232.26,404.4c-.27-3.17-.54-6.35-.81-9.52.56-.1,1.12-.2,1.68-.3,2.82,2.69.75,6.37,1.24,9.54-.7.1-1.41.19-2.11.29h0Z",
    className: "patternColor"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M225.1,400.83v-13.98c.25-.03.5-.05.75-.08v14.01c-.25.02-.5.03-.75.05Z",
    className: "patternColor"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M524.26,404.4l-.82-9.55c.56-.09,1.12-.18,1.68-.28,2.82,2.69.74,6.38,1.25,9.54-.7.1-1.41.19-2.11.29h0Z",
    className: "patternColor"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M239.91,294.6c3.65,1.79,3.57,7.32,0,9.73v-9.73Z",
    className: "patternColor"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M434.62,294.85c-.27,3.18-.54,6.37-.81,9.55-.63-.07-1.25-.15-1.88-.22.07-3.23-1.82-6.75.99-9.56l1.7.23Z",
    className: "patternColor"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M233.82,547.96v9.97h-1.39v-9.88c.46-.03.92-.06,1.39-.1h0Z",
    className: "patternColor"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M332.32,558.2v-10.17c.44,0,.89,0,1.33-.01v10.17c-.44,0-.89,0-1.33.01Z",
    className: "patternColor"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M526.26,582.05v10.12c-3.55-1.56-3.83-6.17,0-10.12Z",
    className: "patternColor"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,235.4v-9.79c3.57,2.68,3.55,7.25,0,9.79Z",
    className: "patternColor"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M485.79,235.98v-10.04c3.55,1.73,3.83,6.13,0,10.04Z",
    className: "patternColor"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M541.04,332.82v13.39c-.3.02-.59.03-.89.05v-13.41c.3,0,.59-.02.89-.03Z",
    className: "patternColor"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M249.14,332.84v13.39c-.32,0-.64,0-.96.01v-13.39c.32,0,.64,0,.96-.01Z",
    className: "patternColor"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M293.78,235.96v-10.04c3.56,1.77,3.84,6.19,0,10.04Z",
    className: "patternColor"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M293.76,542.7v-9.92c3.66,2.48,3.82,6.66,0,9.92Z",
    className: "patternColor"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M271.28,189.01v-13.45c.3,0,.61-.02.91-.03v13.45c-.3,0-.61.02-.91.02h0Z",
    className: "patternColor"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M464.38,175.49v13.53c-.35,0-.71.02-1.06.03v-13.48c.35-.03.71-.05,1.06-.08Z",
    className: "patternColor"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M539.88,500.22v-13.38c.32-.01.64-.02.96-.04v13.4c-.32,0-.64.01-.96.02h0Z",
    className: "patternColor"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M248.03,500.24v-13.39c.29-.02.58-.03.88-.05v13.42c-.29,0-.58.02-.88.03h0Z",
    className: "patternColor"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M432.03,140.55c3.3,2.92,3.36,6.83,0,10.18v-10.18h0Z",
    className: "patternColor"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M272.24,202.02v13.36c-.34,0-.67,0-1.01-.02v-13.38c.34,0,.67.03,1.01.04h0Z",
    className: "patternColor"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M364.28,202.2v13.21c-.36,0-.72-.02-1.07-.03v-13.19l1.07.02h0Z",
    className: "patternColor"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M463.1,215.28v-13.2c.41,0,.82.02,1.23.03v13.4c-.41-.08-.82-.15-1.23-.23Z",
    className: "patternColor"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M448.86,133.72v9.78c-3.25-3.8-2.96-8.27,0-9.78Z",
    className: "patternColor"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M485.92,542.84v-10.31c3.41,3.26,3.49,6.81,0,10.31Z",
    className: "patternColor"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M439.97,192.22v-13.37h1.05v13.37h-1.05Z",
    className: "patternColor"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M334.18,582.61v9.85c-3.57-2.41-3.57-7.15,0-9.85Z",
    className: "patternColor"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M441.19,640.84v13.39c-.32.01-.64.02-.96.04v-13.4c.32,0,.64-.02.96-.03h0Z",
    className: "patternColor"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M194.06,532.14c3.19,3.77,3.1,7.65,0,10.31v-10.31Z",
    className: "patternColor"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M293.84,388.68v-10.05c3.55,3.33,3.62,6.81,0,10.05Z",
    className: "patternColor"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M485.84,388.68v-10.05c3.55,3.33,3.62,6.81,0,10.05Z",
    className: "patternColor"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M586.02,532.42c3.15,3.13,3.18,7.11,0,10.33v-10.33Z",
    className: "patternColor"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M364.26,562.24v11.04c-.38.01-.76.03-1.14.04v-10.92c.38-.05.76-.1,1.14-.16Z",
    className: "patternColor"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M524.27,625.82v-9.86c3.25,4.75,2.9,8.11,0,9.86Z",
    className: "patternColor"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M265.15,428.78c.15,2.92.31,5.84.47,8.92-3.66-1.21-4.17-4.63-.47-8.92Z",
    className: "patternColor"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M554.88,591.77v-9.16c3.67,2.74,3.56,6.44,0,9.16Z",
    className: "patternColor"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M485.96,479.37c3.42,2.37,3.36,6.22,0,9.22v-9.22Z",
    className: "patternColor"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M472.29,405.82v9.36c-3.73-1.06-3.8-4.11,0-9.36Z",
    className: "patternColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternN);
export default __webpack_public_path__ + "static/media/patternN.88949e8c9937030ff0aafc62c925df7f.svg";
export { ForwardRef as ReactComponent };